import { useMemo } from "react"
import { useReserves } from "@/hooks/usePoolReserves"
import type { Pool } from "@/api/pools-api"

export function useBestPool(candidatePools: Pool[], tokenId: string) {
  // For each candidate pool call useReserves and useHopperPrice.
  // (Assume candidatePools is a fixed array – hooks will be called in the same order on each render.)
  const poolData = candidatePools.map((pool) => {
    const [reserves] = useReserves(pool.id, pool.baseToken, pool.quoteToken)

    const emptyReserves =
      !reserves || reserves[pool.quoteToken] === 0n || reserves[pool.baseToken] === 0n
    const liquidity = emptyReserves ? 0n : reserves[tokenId] * 2n

    return { pool, liquidity, emptyReserves }
  })

  // Use useMemo to compute the best pool
  const best = useMemo(() => {
    let bestPool = null
    let maxLiquidity = 0n
    for (const { pool, liquidity, emptyReserves } of poolData) {
      if (!emptyReserves && liquidity > maxLiquidity) {
        bestPool = pool
        maxLiquidity = liquidity
      }
    }
    return { bestPool, liquidity: maxLiquidity }
  }, [poolData])

  return best
}
